import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { AttractionCardComponent } from './attraction.component';
import { CardModule } from '../card.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    LazyLoadImageModule,
    CardModule
  ],
  declarations: [
    AttractionCardComponent
  ],
  exports: [
    AttractionCardComponent
  ]
})
export class AttractionCardModule { }
